import { render, staticRenderFns } from "./MaterialPrice.vue?vue&type=template&id=18bb43f2&"
import script from "./MaterialPrice.vue?vue&type=script&lang=js&"
export * from "./MaterialPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports